import {
    GameRandom,
    Inject,
    ModelEvents,
    Singleton,
} from '@denishussar/html5-game-engine';
import {
    BlockCardsModel,
    ButtonModel,
    CardsColorEnum,
    RightCodeEnum,
} from '../Models/BlockCardsModel';

@Singleton
export class BlockCardsLogic {
    constructor(
        @Inject private _model: BlockCardsModel,
        @Inject private _$random: GameRandom,
        @Inject private _modelEvents: ModelEvents
    ) {}

    private _resultCode = [];
    private _rightAnswersCount: number = 0;

    public reset(): void {
        this._model.buttons = [];
        this._model.codes = [];
        this._model.doneCodes = [];
        this._model.resultCode = '';

        for (let i = 0; i < 13; i++) {
            this._model.buttons.push(new ButtonModel(i));
        }
        for (let i = 0; i < 3; i++) {
            this._model.codes.push(
                this._$random.integer(1000, 9999).toString()
            );
        }

        this._model.isLockedCard = 'active';
        this._model.showHover = 'active';

        this._resultCode = [];
        this._rightAnswersCount = 0;
    }

    public sendResults(): boolean {
        let result = false;
        if (this._isRightCode()) {
            this._model.cards.push(
                CardsColorEnum[`color${this._rightAnswersCount}`]
            );
            this._checkRightIndexCode()
            this._rightAnswersCount++;
            result = true;
            this._model.showHover = 'lock';
        } else {
            this._model.isLockedCard = 'lock';
            result = false;
        }
        this._model.showHover = 'active';
        this._model.isLockedCard = 'active';
        this._resultCode = [];
        this._model.resultCode = '';

        return result;
    }

    private _checkRightIndexCode() {
        this._model.codes.forEach((item, i) => {
            if (item === this._model.resultCode) {
                this._model.doneCodes.push(i);
            }
        });
    }

    public isComplete(): boolean {
        return this._rightAnswersCount >= 3;
    }

    public tapOnNumber(model: ButtonModel): void {
        this._resultCode.push(model.value);
        this._model.resultCode = this._resultCode.join('');
    }

    public deleteNumber(): void {
        this._resultCode.pop();
        this._model.resultCode = this._resultCode.join('');
    }

    private _isRightCode() {
        return this._model.codes.some((code: string) => {
            return this._model.resultCode === code;
        });
    }
}
